export default "__VITE_ASSET__CzQXfSaD__"